/**
 * @class Printer
 */
export default class Printer {
    /**
     * @param {String}  name
     * @param {String}  description
     * @param {String}  comment
     * @param {Boolean} selected
     */
    constructor(name, description = "", comment = "", selected = false) {
        this._name = name;
        this._description = description;
        this._comment = comment;
        this._selected = selected;
    }

    /**
     * @return {String}
     */
    get name() {
        return this._name;
    }

    /**
     * @param {String} name
     */
    set name(name) {
        this._name = name;
    }

    /**
     * @return {String}
     */
    get description() {
        return this._description;
    }

    /**
     * @param {String} description
     */
    set description(description) {
        this._description = description;
    }

    /**
     * @return {String}
     */
    get comment() {
        return this._comment;
    }

    /**
     * @param {String} comment
     */
    set comment(comment) {
        this._comment = comment;
    }

    /**
     * @return {Boolean}
     */
    get selected() {
        return this._selected;
    }

    /**
     * @param {Boolean} selected
     */
    set selected(selected) {
        this._selected = selected;
    }

    /**
     * @return {Object}
     */
    clone() {
        return new Printer(this._name, this._description, this._comment, this._selected);
    }

    /**
     * Clones Printer object and updates name property.
     *
     * @param   {String} name
     * @return  {Object}
     */
    updateName = (name) => {
        let printer = this.clone();
        printer.name = name;

        return printer;
    };
}
